










































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';

@Component({
  name: 'bc-pos-cash-movements-modal',
  components: {
    'bpc-input-group': InputGroup,
    'bc-textarea': Textarea,
  },
})
export default class PosCashMovementsModal extends Vue {
  // PROPS
  @Prop({ type: Number, required: true }) readonly posSessionId: number;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: String, default: '' }) readonly cashMovementType: string;

  // DATA
  loading = false;
  amount = 0;
  justification = '';

  closeModal() {
    this.resetValues();
    this.$emit('close');
  }

  resetValues() {
    this.amount = 0;
    this.justification = '';
  }

  async postCashMovement() {
    this.loading = true;
    try {
      await this.$posService.postCashMovement(
        this.posSessionId,
        this.cashMovementType,
        this.amount,
        this.justification,
      );
      this.$bpcMessage.showSuccessMessage({ text: 'pos.cash_movement.modal.success' });
      this.resetValues();
      this.closeModal();
    } catch (error) {
      this.handleError(error);
    }
    this.loading = false;
  }

  handleError(error: any) {
    if (error.response && error.response.data) {
      this.$bpcMessage.showErrorMessage({ text: error.response.data.message });
    } else {
      this.$bpcMessage.showErrorMessage({ text: 'global.error' });
    }
  }

  get titlePosCashMovementModal() {
    if (this.cashMovementType === 'cash_out') {
      return this.$t('pos.cash_movement_out.modal.title');
    }
    return this.$t('pos.cash_movement_in.modal.title');
  }
}
